import { cn } from '@/lib/utils'
import type { StatusFamily } from '@/types'

// One pill for every "state" in the app — transaction status, merchant
// active/inactive, credentials configured, action succeeded/failed — all mapped
// to the five brand status families (DESIGN_GUIDELINES §2). Color is always
// paired with a text label (never color alone — a11y §7).
const FAMILY_CLASSES: Record<StatusFamily, string> = {
  success: 'bg-status-success-bg text-status-success-fg',
  pending: 'bg-status-pending-bg text-status-pending-fg',
  warning: 'bg-status-warning-bg text-status-warning-fg',
  failed: 'bg-status-failed-bg text-status-failed-fg',
  neutral: 'bg-status-neutral-bg text-status-neutral-fg',
}

export function StatusPill({ family, children }: { family: StatusFamily; children: React.ReactNode }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        FAMILY_CLASSES[family] ?? FAMILY_CLASSES.neutral,
      )}
    >
      {children}
    </span>
  )
}
